import { useCallback,useState } from 'react';
import {
    type Node,
  ReactFlow,
  addEdge,
  Background,
  useNodesState,
  useEdgesState,
  applyEdgeChanges,
  applyNodeChanges,
  MiniMap,
  Controls,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';



const initialNodes :Node[]  = [
  {
    id: 'A',
    type: 'group',
    position: { x: 0, y: 0 },
    style: {
      width: 170,
      height: 140,
    },
    data: {},
  },
  {
    id: 'A-1',
    type: 'input',
    data: { label: 'Child Node 1' },
    position: { x: 10, y: 10 },
    parentId: 'A',
    extent: 'parent',
  },
  {
    id: 'A-2',
    data: { label: 'Child Node 2' },
    position: { x: 10, y: 90 },
    parentId: 'A',
    extent: 'parent',
  },
  {
    id: 'B',
    type: 'output',
    position: { x: -100, y: 200 },
    data: { label: 'Node B' },
  },
  {
    id: 'C',
    type: 'output',
    position: { x: 100, y: 200 },
    data: { label: 'Node C' },
  },
];

const initialEdges = [
  { id: 'a1-a2', source: 'A-1', target: 'A-2' },
  { id: 'a2-b', source: 'A-2', target: 'B' },
  { id: 'a2-c', source: 'A-2', target: 'C' },
];

const rfStyle = {
    backgroundColor: '#D0C0F7',
  };
  
const NestedFlow = () => {
  
  
    const [nodes, setNodes] = useState(initialNodes);
    const [edges, setEdges] = useState(initialEdges);
  
    const onNodesChange = useCallback(
      (changes:any) => setNodes((nds) => applyNodeChanges(changes, nds)),
      [setNodes],
    );
    const onEdgesChange = useCallback(
      (changes:any) => setEdges((eds) => applyEdgeChanges(changes, eds)),
      [setEdges],
    );
    const onConnect = useCallback(
      (connection:any) => setEdges((eds) => addEdge(connection, eds)),
      [setEdges],
    );

  return (
    <ReactFlow
    nodes={nodes}
    edges={edges}
    onEdgesChange={onEdgesChange}
    onNodesChange={onNodesChange}
    onConnect={onConnect}
    fitView
    style={rfStyle}
    attributionPosition="top-right"
  >
    <Background />
  </ReactFlow>
  );
};

export default NestedFlow;
